import React, { Component } from 'react';
import EWH from '../components/EWH';
import EventPaths from '../components/Paths';
import { useParams } from "react-router-dom";

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}


export class Comune extends Component {
  render() {
    let { regione, provincia, comune} = this.props.params;
    let path = EventPaths[regione];
    let repoFascione = "/elezioni/withub/" + path + "/regionali/" + regione + "/fascione.html";
    let repoDettaglio = "/elezioni/withub/" + path + "/regionali/" + regione + "/province/" + provincia + "/" + comune + ".html";
    return (
    <div className="App">
        <EWH id="ewh-fascione" repo={repoFascione} />
        <EWH id="ewh-dettaglio" repo={repoDettaglio} />
    </div>
    )
  }
}

export default withParams(Comune)
